import { useMemo } from "react";

const dateTimeFormat = new Intl.DateTimeFormat("en", {
    year: "2-digit",
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
});

export const useDateFormat = (seconds: number): string | null => {
    return useMemo(() => {
        if (!seconds) {
            return null;
        }
        return dateTimeFormat.format(seconds * 1000).replace(",", "");
    }, [seconds]);
};
